export default __webpack_public_path__ + "static/media/reload.7df68697.svg";